export const MSA_URL = 'https://wisprflow.ai/legal/msa'
export const DPA_URL = 'https://wisprflow.ai/legal/dpa'
